var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.$t("details.title"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ring-card__header-buttons" }, [
          !_vm.editMode
            ? _c("a", { on: { click: _vm.editForm } }, [
                _vm._v(" " + _vm._s(_vm.$t("common.edit"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode
            ? _c(
                "a",
                {
                  staticClass: "save-edit-mode",
                  on: { click: _vm.submitForm },
                },
                [_vm._v(" " + _vm._s("Save "))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode
            ? _c("a", { on: { click: _vm.cancelForm } }, [
                _vm._v(" " + _vm._s("Cancel")),
              ])
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.updating.loading || _vm.customer.id === undefined,
            expression: "updating.loading || customer.id === undefined ",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "el-form",
          {
            ref: "profileForm",
            attrs: {
              model: _vm.updating.form,
              rules: _vm.profileForm.rules,
              inline: true,
            },
          },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.full_name")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editMode && _vm.allowEditName,
                          expression: "editMode && allowEditName",
                        },
                      ],
                      staticClass:
                        "ring-card__input cus-details-fullname__edit",
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "firstName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "First name",
                              "inline-message": "true",
                            },
                            model: {
                              value: _vm.updating.form.firstName,
                              callback: function ($$v) {
                                _vm.$set(_vm.updating.form, "firstName", $$v)
                              },
                              expression: "updating.form.firstName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "lastName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "Last name",
                              "inline-message": "true",
                            },
                            model: {
                              value: _vm.updating.form.lastName,
                              callback: function ($$v) {
                                _vm.$set(_vm.updating.form, "lastName", $$v)
                              },
                              expression: "updating.form.lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editMode || !_vm.allowEditName,
                          expression: "!editMode || !allowEditName",
                        },
                      ],
                      staticClass: "ring-card__input",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.customer.first_name) +
                          " " +
                          _vm._s(_vm.customer.last_name) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.primary_email")) +
                        "\n            "
                    ),
                    _vm.allowEditEmail
                      ? _c(
                          "span",
                          [
                            _c("customer-email-form", {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl.enable",
                                  value: {
                                    permission: "update-primary-email",
                                    on: "Customer",
                                  },
                                  expression:
                                    "{permission: 'update-primary-email', on: 'Customer'}",
                                  modifiers: { enable: true },
                                },
                              ],
                              attrs: {
                                customer: _vm.customer,
                                "update-fn": _vm.updateCustomerEmail,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ring-card__input",
                      staticStyle: { display: "block" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.customer.email) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.created_at")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ring-card__input" },
                    [
                      _c("time-zone-formatter", {
                        attrs: { "current-time": _vm.customer.created_at },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.secondary_email")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editMode,
                          expression: "editMode",
                        },
                      ],
                      staticClass: "ring-card__input cus-details-field__edit",
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "altEmail" } },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl.enable",
                                value: {
                                  permission: "update-secondary-email",
                                  on: "Customer",
                                },
                                expression:
                                  "{permission: 'update-secondary-email', on: 'Customer'}",
                                modifiers: { enable: true },
                              },
                            ],
                            attrs: {
                              size: "small",
                              placeholder: "Secondary email",
                              "inline-message": "true",
                            },
                            model: {
                              value: _vm.updating.form.altEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.updating.form, "altEmail", $$v)
                              },
                              expression: "updating.form.altEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editMode,
                          expression: "!editMode",
                        },
                      ],
                      staticClass: "ring-card__input",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.altEmail || "N/A") +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v("\n            Legal Country\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ring-card__input" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.legalCountry) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.phone")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.editMode
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ring-card__input cus-details-field__edit",
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "phoneNumber" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "Phone number",
                                  "inline-message": "true",
                                },
                                model: {
                                  value: _vm.updating.form.phoneNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updating.form,
                                      "phoneNumber",
                                      $$v
                                    )
                                  },
                                  expression: "updating.form.phoneNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "ring-card__input" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.customer.phone_number || "No number") +
                            "\n          "
                        ),
                      ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("details.referrals")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ring-card__input" }, [
                    _vm._v("\n            N/A\n          "),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl.show",
                        value: { permission: "fraud-report", on: "Customer" },
                        expression:
                          "{permission: 'fraud-report', on: 'Customer'}",
                        modifiers: { show: true },
                      },
                    ],
                    attrs: { span: 8 },
                  },
                  [
                    _c("div", { staticClass: "ring-card__input-label" }, [
                      _vm._v("\n            Fraud Detection\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ring-card__input" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              title: "Fraud Detection",
                              width: "250",
                              trigger: "click",
                            },
                            model: {
                              value: _vm.toggleFraudModal,
                              callback: function ($$v) {
                                _vm.toggleFraudModal = $$v
                              },
                              expression: "toggleFraudModal",
                            },
                          },
                          [
                            !_vm.customer.profile.fraud
                              ? _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "word-break": "break-word",
                                      "font-size": "13px",
                                      color: "#f56c6c",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-warning" }),
                                    _vm._v(
                                      "\n                Are you sure to send a fraud report for this customer?\n              "
                                    ),
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "word-break": "break-word",
                                      "font-size": "13px",
                                      color: "#f56c6c",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Are you sure to remove this fraud report for the customer?\n              "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "right",
                                  margin: "0",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.toggleFraudModal = false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  cancel\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reportFraud()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  confirm\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-switch", {
                              attrs: {
                                slot: "reference",
                                value: _vm.customer.profile.fraud,
                              },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl.show",
                        value: { permission: "view", on: "DCCS3" },
                        expression: "{permission: 'view', on: 'DCCS3' }",
                        modifiers: { show: true },
                      },
                    ],
                    attrs: { span: 8 },
                  },
                  [
                    _c("div", { staticClass: "ring-card__input-label" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("details.account_type")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ring-card__input" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.accountTypeDescription) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v("\n            2SV Status\n          "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ring-card__input" },
                    [
                      _c("TSVStatus", {
                        attrs: { "is-on": _vm.tfaEnabled, phone: _vm.tfaPhone },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl.show",
                        value: { permission: "accountSummary", on: "NewUI" },
                        expression:
                          "{permission: 'accountSummary', on: 'NewUI'}",
                        modifiers: { show: true },
                      },
                    ],
                    attrs: { span: 8 },
                  },
                  [
                    _c("div", { staticClass: "ring-card__input-label" }, [
                      _vm._v("\n            Account Locked\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ring-card__input" },
                      [_c("LockAccountSwitch")],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl.show",
                        value: { permission: "reset-password", on: "Customer" },
                        expression:
                          "{permission: 'reset-password', on: 'Customer' }",
                        modifiers: { show: true },
                      },
                    ],
                    attrs: { span: 8 },
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "top" },
                        model: {
                          value: _vm.confirmVisible,
                          callback: function ($$v) {
                            _vm.confirmVisible = $$v
                          },
                          expression: "confirmVisible",
                        },
                      },
                      [
                        _c("p", [_vm._v("Are you sure to reset password?")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { "text-align": "right", margin: "0" },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelReset()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Cancel\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendResetPassword()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Yes, confirm\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allowResetPassword,
                                expression: "allowResetPassword",
                              },
                            ],
                            class: [
                              "ring-card__text--actionable",
                              _vm.loadingReset ? "disabled" : "",
                            ],
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm.loadingReset
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("details.reset_password")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.updating.errors
          ? _c("el-alert", {
              staticStyle: { "margin-top": "20px" },
              attrs: {
                title: "Saving error",
                type: "warning",
                description: "Customer details could not be updated",
                "show-icon": "",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }